import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const reassurances = ['Descarga instantánea tras el pago', 'Un solo pago, sin suscripciones', 'Acceso de por vida a los 12 niveles', 'Garantía de 7 días sin preguntas'];
export function Offer() {
  return <section id="offer" className="relative w-full overflow-hidden bg-ink px-5 py-20 sm:py-28" data-id="element-156" data-mp="tylglr1tuctm">
      <div className="bg-stripes absolute inset-0" aria-hidden="true" data-id="element-157" data-mp="p0jvl0kuc3fi" />
      <div className="relative mx-auto max-w-xl" data-id="element-158" data-mp="13x16jqp4bg1j">
        <Reveal className="text-center" data-id="element-159" data-mp="13xst6c0qm3fo">
          <span className="inline-flex rounded-full bg-volt px-4 py-1.5 font-display text-xs tracking-[0.16em] text-ink" data-id="element-160" data-mp="yxxzk0pkuzqx">
            Oferta especial de lanzamiento
          </span>
          <h2 className="balance mt-6 font-display text-[2.4rem] leading-[0.98] text-white sm:text-[3.4rem]" data-id="element-161" data-mp="2feami391fpy3">
            Kit INGLES LISTO™{' '}
            <span className="text-brand" data-id="element-162" data-mp="pl0dpx6ki0fg">completo</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-163" data-mp="uj1zwqzaifv5">
          <div className="relative mt-12 rounded-3xl border-2 border-ink bg-white px-6 pb-8 pt-12 shadow-lift sm:px-9" data-id="element-164" data-mp="ui0kybf5l985">
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border-2 border-ink bg-brand px-5 py-1.5 font-display text-xs tracking-[0.14em] text-white" data-id="element-165" data-mp="zj6do98tcwho">
              12 volúmenes + 5 bonos
            </span>

            <dl data-id="element-166" data-mp="bsas3tuyaxiv">
              {offerRows.map(row => <div key={row.label} className="flex items-start justify-between gap-4 border-b border-ink/10 py-4" data-id="element-167" data-mp="bqpyc6ggnim2">
                  <dt className="text-base leading-snug text-ink/75" data-id="element-168" data-mp="klxh914nl2j3">
                    {row.label}
                  </dt>
                  <dd className="shrink-0 font-bold text-ink/40 line-through" data-id="element-169" data-mp="3k6jc4djeqfzf">
                    {row.value}
                  </dd>
                </div>)}
              <div className="flex items-center justify-between gap-4 border-b-2 border-ink py-4" data-id="element-170" data-mp="vefrpxtx9wyz">
                <dt className="font-display text-lg text-ink" data-id="element-171" data-mp="qfup5rr7717d">Valor total</dt>
                <dd className="shrink-0 font-display text-lg text-ink/40 line-through" data-id="element-172" data-mp="155tohxuhoiof">
                  $171 USD
                </dd>
              </div>
            </dl>

            <p className="mt-8 text-center font-display text-sm tracking-[0.18em] text-brand" data-id="element-173" data-mp="cgmpyyv1bt36">
              Solo por hoy
            </p>
            <p className="mt-2 text-center" data-id="element-174" data-mp="7itim2hzwt1b">
              <span className="font-display text-[4.5rem] leading-none text-ink sm:text-[5.5rem]" data-id="element-175" data-mp="7k4pib6qmgwn">
                $17
              </span>
              <span className="mt-2 block text-sm font-bold uppercase tracking-[0.16em] text-ink/50" data-id="element-176" data-mp="hfptufza3t9k">
                USD · pago único
              </span>
              <span className="mx-auto mt-3 block max-w-xs text-xs font-semibold leading-relaxed text-ink/45" data-id="element-177" data-mp="1wykomjfamriy">
                El cobro se hace en la moneda de tu país, con la conversión
                automática del día.
              </span>
            </p>

            <CtaButton label="¡Quiero mi Kit ahora!" note="Sin suscripciones · Acceso de por vida" className="mt-8 w-full" data-id="element-178" data-mp="25ei6ybb3o06r" />

            <p className="mt-4 flex items-center justify-center gap-2 text-xs text-ink/50" data-id="element-179" data-mp="1veresga0hx9u">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-180" data-mp="2j4vfofvtfix5" />
              <span data-id="element-181" data-mp="2o48dtws50cf1">Pago 100% seguro y encriptado</span>
            </p>

            <ul className="mt-6 space-y-2.5" data-id="element-182" data-mp="2o3ggohiw66mn">
              {reassurances.map(item => <li key={item} className="flex items-center gap-2.5 text-sm font-semibold text-ink/70" data-id="element-183" data-mp="29esnghwiq8zv">
                  <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-volt" data-id="element-184" data-mp="323hgrurc1a12">
                    <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" strokeWidth={3} data-id="element-185" data-mp="36vrehwyovedw" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}